import { Component, Input, OnInit } from "@angular/core";
import { ModelService } from "../Services/model.service";
import { UpdateTemplate } from '../Model/Catalog/UpdateTemplate';
import { CustomerWiki } from '../Model/System/CustomerWiki';
import { TemplateItemTemplate } from '../Model/Catalog/TemplateItemTemplate';
import { UpdateTemplateItem } from '../Model/Catalog/UpdateTemplateItem';
import { TranslateService } from "@ngx-translate/core";



@Component({
  selector: "updateTemplates",
  templateUrl: "updateTemplates.component.html"
})
export class UpdateTemplatesComponent implements OnInit {

  @Input() helpSwitch?: boolean = true;

  model: UpdateTemplate[];

  

  constructor(public modelService: ModelService, public translate: TranslateService) {

    this.translate.get('Update Templates').subscribe((text: string) => {
      this.modelService.systemService.currentNavigationTitle = text;
    });
  }

  onToolbarPreparing(e) {

    e.toolbarOptions.items.unshift({
      location: 'before',
      locateInMenu: 'auto',
      template: 'newTemplateButtonTemplate'
    });    
  }



  ngOnInit(): void {
    if (this.modelService.loginService.currentUser == null) {
      this.modelService.router.navigate(["/"]);
      return;
    }

    this.modelService.updateTemplateService.getUpdateTemplates().subscribe(
      (result: UpdateTemplate[]) => {
        this.model = result;
      });
    this.modelService.catalogService.loadFields();

   
  }




  onSelectionChangedClick(e) {
    this.modelService.updateTemplateService.selectedTemplate = e.data;
    this.checkAllFieldsExist();
  }

  checkAllFieldsExist() {
    this.fields.forEach((field: TemplateItemTemplate) => {
      if (this.modelService.updateTemplateService.selectedTemplate.items.find(element => element.field == field.field) == undefined) {
        let item = new UpdateTemplateItem();
        item.field = field.field;
        item.group = field.group;
        item.isActive = false;
        if (item.field == "SUPPLIER_PID")
          item.isActive = true;
        this.modelService.updateTemplateService.selectedTemplate.items.push(item);
      }
    });        
  }

  get fields() {
    return this.modelService.catalogService.fields;
  }


  onDeleteClicked(e) {
    this.modelService.updateTemplateService.deleteUpdateTemplate(e.data);
  }

  addTemplate() {

    let updateTemplate = new UpdateTemplate();
    updateTemplate.customerId = this.modelService.loginService.currentUser.customerId;
   
    this.modelService.updateTemplateService.addUpdateTemplate(updateTemplate).subscribe(
      (result: UpdateTemplate) => {        
        this.modelService.updateTemplateService.selectedTemplate = result;
        this.checkAllFieldsExist();
        this.model.push(this.modelService.updateTemplateService.selectedTemplate);
      });
  }

  toggleHelp() {
    this.modelService.systemService.showHelp = !this.modelService.systemService.showHelp;
    if (this.modelService.systemService.showHelp) {
      this.modelService.systemService.loadHelp(this.modelService.loginService.currentUser.customerId).subscribe((result: CustomerWiki) => this.modelService.systemService.help = result.entries);
    }
  }
}
